import { requestAnimationFrame as rAF, cancelAnimationFrame as cancelRAF } from 'request-animation-frame-polyfill';
var requestAF = rAF;
var cancelAF = cancelRAF;
/**
 * use user-defined raf instead of requestAnimationFrame
 */

export function patch(requestAFPatch, cancelAFPatch) {
  requestAF = requestAFPatch;
  cancelAF = cancelAFPatch;
}
export var requestAnimationFrame = requestAF;
export var cancelAnimationFrame = cancelAF;